import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from '../../utils/classNames';
import HighlightedNumber from '../HighlightedNumber';
import styles from './Steps.module.css';
const ItemDivider = _jsx("span", Object.assign({ className: styles.segmentDivider }, { children: "-----" }), void 0);
const renderEachRemainingItem = (howManyStepsCompleted) => (step, index) => {
    const numberLabel = howManyStepsCompleted + index + 1;
    const key = `steplabel${howManyStepsCompleted + index}`;
    if (index === 0) {
        const activeStep = (_jsxs("div", Object.assign({ className: classNames(styles.stepLabel, styles.active) }, { children: [_jsx(HighlightedNumber, { color: "linear-gradient(to right bottom, var(--turquoise-basePlus25), var(--turquoise-baseMinus50))", value: numberLabel }, void 0), _jsx("span", Object.assign({ className: styles.marginLeft }, { children: step }), void 0)] }), key));
        return activeStep;
    }
    return (_jsxs("div", Object.assign({ className: styles.stepLabel }, { children: [ItemDivider, _jsx(HighlightedNumber, { color: "var(--ambient-basePlus75)", value: numberLabel }, void 0), _jsx("span", Object.assign({ className: styles.marginLeft }, { children: step }), void 0)] }), key));
};
const renderEachCompletedItem = (step, index) => {
    const key = `steplabel${index}`;
    return (_jsxs("div", Object.assign({ className: classNames(styles.stepLabel, styles.completed) }, { children: [_jsx(HighlightedNumber, { color: "var(--ambient-baseMinus50)", value: index + 1 }, void 0), _jsx("span", Object.assign({ className: styles.marginLeft }, { children: step }), void 0), ItemDivider] }), key));
};
const Steps = ({ stepsList, currentIndex }) => {
    const completedItems = stepsList.slice(0, currentIndex);
    const remainingItems = stepsList.slice(currentIndex);
    const completedSteps = completedItems.map(renderEachCompletedItem);
    const remainingSteps = remainingItems.map(renderEachRemainingItem(completedItems.length));
    return (_jsxs("div", Object.assign({ className: styles.stepsBar }, { children: [completedSteps, remainingSteps] }), void 0));
};
export default Steps;
